<section class="ridango-mat-table">
    <table mat-table [dataSource]="dataSource" [attr.aria-busy]="loading"
        [attr.aria-label]="'PURCHASE_HISTORY_TABLE_ARIA_LABEL' | translate"
        matSort matSortActive="starting" matSortDirection="desc">
        <ng-container matColumnDef="name">
            <th mat-header-cell mat-sort-header *matHeaderCellDef scope="col">{{'PURCHASE_HISTORY_TABLE_HEADER_NAME' | translate}}
            </th>
            <td mat-cell *matCellDef="let ticket">
                <span class="hide-desktop show-mobile">{{'PURCHASE_HISTORY_TABLE_HEADER_NAME' | translate}}</span>
                {{ ticket.product_name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="price">
            <th mat-header-cell mat-sort-header *matHeaderCellDef scope="col">{{'PURCHASE_HISTORY_TABLE_HEADER_PRICE' | translate}}
            </th>
            <td mat-cell *matCellDef="let ticket">
                <span class="hide-desktop show-mobile">{{'PURCHASE_HISTORY_TABLE_HEADER_PRICE' |
                    translate}}</span>
                <div *ngIf="ticket.price === '-'">&ndash;</div>
                <div *ngIf="ticket.price !== '-'">{{ ticket.price }} {{ currency | translate }}
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="starting">
            <th mat-header-cell mat-sort-header *matHeaderCellDef scope="col">{{'TABLE_HEADER_STARTING' | translate}}</th>
            <td mat-cell *matCellDef="let ticket">
                <span class="hide-desktop show-mobile">{{'TABLE_HEADER_STARTING' | translate}}</span>
                {{ ticket.starting | date: dateFormat }}
            </td>
        </ng-container>

        <ng-container matColumnDef="ending">
            <th mat-header-cell mat-sort-header *matHeaderCellDef scope="col">{{'TABLE_HEADER_ENDING' | translate}}</th>
            <td mat-cell *matCellDef="let ticket">
                <span class="hide-desktop show-mobile">{{'TABLE_HEADER_ENDING' | translate}}</span>
                {{ ticket.ending | date: dateFormat }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status">
            <th mat-header-cell mat-sort-header *matHeaderCellDef scope="col">{{'TABLE_HEADER_STATUS' | translate}}</th>
            <td mat-cell *matCellDef="let ticket">
                <span class="hide-desktop show-mobile">{{'TABLE_HEADER_STATUS' | translate}}</span>
                {{ ticket.status }}
            </td>
        </ng-container>

        <ng-container matColumnDef="receipt">
            <th mat-header-cell *matHeaderCellDef scope="col">{{'PURCHASE_HISTORY_TABLE_HEADER_RECEIPT' | translate}}
            </th>
            <td mat-cell *matCellDef="let ticket">
                <span class="hide-desktop show-mobile">{{'PURCHASE_HISTORY_TABLE_HEADER_RECEIPT' | translate}}</span>
                <a *ngIf="ticket.jwt_token" class="link--action link--emphasized link" (click)="getPdf(ticket)">PDF</a>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="purchaseTicketsTableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: purchaseTicketsTableColumns;"></tr>
    </table>
</section>
